module.exports = __webpack_public_path__ + "media/images/admin/icons/bar-chart-fb875840099913f1fb3f5b820fc60038.svg";